// 文档库
export default {
  name: 'documentLibrary',
  //获得文档库列表
  docLibs: {
    url: '/rc-api/docLibs'
  }
}
